export default __webpack_public_path__ + "static/media/matic_sm.79a0add5.svg";